<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="(showGetrank = true) && (neuGetrank = true) && (getrank = [])"
            ><v-icon>add</v-icon></v-btn
          >
        </template>
        <span>Erstellen</span>
      </v-tooltip>
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon disabled v-on="on"><v-icon>save_alt</v-icon></v-btn>
        </template>
        <span>Exportieren</span>
      </v-tooltip> -->
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Suchen"
          single-line
          solo
          flat
          hide-details
          clearable
          clear-icon="close"
        ></v-text-field>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>

    <v-row class="ma-0">
      <v-col cols="12">
        <v-card outlined>
          <v-data-table
            dense
            :height="sideHeight"
            :headers="headers"
            :items="getranke"
            :search="search"
            fixed-header
            hide-default-footer
            :items-per-page="-1"
            :hide-default-header="$vuetify.breakpoint.xsOnly"
            no-data-text="Keine Getränke vorhanden"
          >
            <template v-slot:header="{ item }">
              <tr class="hidden-sm-and-up">
                <th>Was</th>
                <th>Einkaufspreis</th>
              </tr>
            </template>
            <template v-slot:item="{ item }">
              <tr
                :class="!item.switchZahlung ? 'red lighten-4' : ''"
                v-on:dblclick="(getrank = item) && (showGetrank = true) && (neuGetrank = false)"
              >
                <td>{{ item.bezeichnung }}</td>
                <td class="text-right">{{ item.preis | money }}</td>
                <td class="text-right hidden-xs-only">{{ item.verkaufseinheit }}</td>
                <td class="text-right hidden-xs-only">{{ item.verkauf1 | money }}</td>
                <td class="text-right hidden-xs-only">{{ item.verkauf2 | money }}</td>
                <td class="text-right hidden-xs-only">{{ item.verkauf3 | money }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="showGetrank" :fullscreen="$vuetify.breakpoint.smAndDown" width="70%" persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
        <v-card-title>
          <div v-if="neuGetrank" class="pr-1">Neues Getränk erstellen</div>
          {{ getrank.bezeichnung }}
          <v-spacer></v-spacer>
          <v-btn icon @click="showGetrank = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-app-bar dense flat class="transparent">
          <v-tabs v-model="num" grow>
            <v-tab><v-icon class="mr-2">info</v-icon>Info</v-tab>
            <v-tab v-if="!neuGetrank"><v-icon class="mr-2">insights</v-icon>Statistik</v-tab>
          </v-tabs>
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text>
          <v-tabs-items v-model="num">
            <v-tab-item>
              <v-row class="pa-0 ma-0 mt-4">
                <v-col cols="12" md="6" lg="6" class="py-0">
                  <v-text-field dense outlined label="Bezeichnung" v-model="getrank.bezeichnung"></v-text-field>
                </v-col>
                <v-col cols="6" md="6" lg="3" class="py-0">
                  <v-text-field
                    dense
                    outlined
                    label="Flaschen/Gebinde"
                    hint="Anzahl Flaschen pro Kiste"
                    v-model="getrank.verkaufseinheit"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" md="6" lg="3" class="py-0">
                  <v-text-field dense outlined label="Volumen/Flasche" v-model="getrank.volumen"></v-text-field>
                </v-col>
                <v-col cols="6" md="6" lg="3" class="py-0">
                  <v-text-field dense outlined label="Preis/Gebinde inkl. MwSt." v-model="getrank.preis"></v-text-field>
                </v-col>
                <v-col cols="6" md="6" lg="3" class="py-0">
                  <v-text-field
                    dense
                    outlined
                    label="Preis/Gebinde exkl. MwSt."
                    disabled
                    v-model="preisexcl"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" md="6" lg="3" class="py-0">
                  <v-text-field
                    dense
                    outlined
                    label="Pfand"
                    hint="Für eine Kiste"
                    v-model="getrank.pfand"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" md="6" lg="3" class="py-0">
                  <v-text-field dense outlined label="Striche pro Flasche" v-model="getrank.striche"></v-text-field>
                </v-col>
                <v-col cols="6" md="6" lg="3" class="py-0">
                  <v-text-field
                    dense
                    outlined
                    label="Verkaufspreis 1"
                    hint="Wird für EKP verwendet"
                    v-model="getrank.verkauf1"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" md="6" lg="3" class="py-0">
                  <v-text-field
                    dense
                    outlined
                    label="Verkaufspreis 2"
                    hint="Kann in Abrechnungen verwendet werden"
                    v-model="getrank.verkauf2"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" md="6" lg="3" class="py-0">
                  <v-text-field
                    dense
                    outlined
                    label="Verkaufspreis 3"
                    hint="Kann in Abrechnungen verwendet werden"
                    v-model="getrank.verkauf3"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" md="6" lg="3" class="py-0">
                  <v-select dense outlined :items="kategorien" label="Standard" v-model="getrank.kategorie"></v-select>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-switch dense class="mt-0" v-model="getrank.switchPfand" label="Pfand zählen"></v-switch>
                  <v-switch dense class="mt-0" v-model="getrank.switchEkp" label="EKP erlauben"></v-switch>
                  <v-switch
                    dense
                    class="mt-0"
                    v-model="getrank.switchBestellung"
                    label="Getränk kann bestellt werden"
                  ></v-switch>
                  <v-switch
                    dense
                    class="mt-0"
                    v-model="getrank.switchZahlung"
                    label="Getränk kann gezählt werden"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item v-if="!neuGetrank">
              <v-row no-gutters>
                <v-col cols="12" class="pt-8 pb-0 mb-0">
                  <v-slider
                    v-model="anzahl"
                    max="24"
                    min="1"
                    :thumb-size="24"
                    thumb-label="always"
                    ticks="always"
                    tick-size="4"
                  >
                  </v-slider>
                </v-col>
                <v-col cols="4" class="pa-1">
                  <v-card outlined>
                    <v-card-title class="ma-0 py-1 px-2">
                      Verbraucht
                      <v-spacer></v-spacer>
                      <v-chip small
                        >Ø
                        {{
                          (
                            (statistiken.verbraucht.data.reduce((a, b) => a + b, 0) /
                              statistiken.verbraucht.data.length) *
                            getrank.volumen
                          ).toFixed(1)
                        }}
                        l</v-chip
                      >
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <v-progress-linear
                        v-for="(item, index) in statistiken.verbraucht.data"
                        :key="index"
                        rounded
                        height="16"
                        class="mb-1"
                        :value="(item / Math.max(...statistiken.verbraucht.data)) * 100"
                      >
                        <v-row no-gutters class="mx-2">
                          <v-col cols="6">{{ $filters.date(statistiken.monate[index], "MM.YY") }}</v-col>
                          <v-col cols="6" class="text-right">{{ (item * getrank.volumen).toFixed(0) }} l</v-col>
                        </v-row>
                      </v-progress-linear>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-1">
                  <v-card outlined>
                    <v-card-title class="ma-0 py-1 px-2">
                      EKP
                      <v-spacer></v-spacer>
                      <v-chip small
                        >Ø
                        {{
                          (
                            (statistiken.ekp.data.reduce((a, b) => a + b, 0) / statistiken.ekp.data.length) *
                            getrank.volumen
                          ).toFixed(1)
                        }}
                        l</v-chip
                      >
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <v-progress-linear
                        v-for="(item, index) in statistiken.ekp.data"
                        :key="index"
                        rounded
                        height="16"
                        class="mb-1"
                        :value="(item / Math.max(...statistiken.ekp.data)) * 100"
                      >
                        <v-row no-gutters class="mx-2">
                          <v-col cols="6">{{ $filters.date(statistiken.monate[index], "MM.YY") }}</v-col>
                          <v-col cols="6" class="text-right">{{ (item * getrank.volumen).toFixed(0) }} l</v-col>
                        </v-row>
                      </v-progress-linear>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-1">
                  <v-card outlined>
                    <v-card-title class="ma-0 py-1 px-2">
                      Ende
                      <v-spacer></v-spacer>
                      <v-chip small
                        >Ø
                        {{
                          (
                            (statistiken.ende.data.reduce((a, b) => a + b, 0) / statistiken.ende.data.length) *
                            getrank.volumen
                          ).toFixed(1)
                        }}
                        l</v-chip
                      >
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <v-progress-linear
                        v-for="(item, index) in statistiken.ende.data"
                        :key="index"
                        rounded
                        height="16"
                        class="mb-1"
                        :value="(item / Math.max(...statistiken.ende.data)) * 100"
                      >
                        <v-row no-gutters class="mx-2">
                          <v-col cols="6">{{ $filters.date(statistiken.monate[index], "MM.YY") }}</v-col>
                          <v-col cols="6" class="text-right">{{ (item * getrank.volumen).toFixed(0) }} l</v-col>
                        </v-row>
                      </v-progress-linear>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showGetrank = false">Abbrechen</v-btn>
          <v-btn v-if="neuGetrank" class="primary" text @click="createGetrank()">Speichern</v-btn>
          <v-btn v-else class="primary" text @click="updateGetrank()">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialogDelete
      :visible.sync="showDeleteGetrank"
      title="Getränk löschen"
      message="Willst du dieses Getränk wirklich löschen?"
      abbrechen="Abbrechen"
      weiter="Löschen"
      @closeTrue="deleteGetrank()"
      @closeFalse="showDeleteGetrank = false"
    >
    </dialogDelete>
  </v-container>
</template>

<script>
  export default {
    props: ["on"],
    data() {
      return {
        headers: [
          { text: "Bezeichnung", align: "left", value: "bezeichnung" },
          { text: "Preis", align: "right", value: "preis" },
          { text: "Gebinde", align: "right", value: "gebinde" },
          { text: "Verkauf 1", align: "right", value: "verkauf1" },
          { text: "Verkauf 2", align: "right", value: "verkauf2" },
          { text: "Verkauf 3", align: "right", value: "verkauf3" },
        ],
        kategorien: ["Bier", "Softdrinks", "Wein & Schnaps"],
        selected: [],
        search: "",
        showGetrank: false,
        getrank: [],
        neuGetrank: false,
        showDeleteGetrank: false,
        num: 0,
        anzahl: 12,
      };
    },
    computed: {
      sideHeight() {
        if (this.$store.state.user.user !== null && this.$store.state.user.user !== undefined) {
          switch (this.$vuetify.breakpoint.name) {
            case "xs":
              return "calc(100vh - 191px)";
            case "sm":
              return "calc(100vh - 169px)";
            case "md":
              return "calc(100vh - 199px)";
            case "lg":
              return "calc(100vh - 191px)";
            case "xl":
              return "calc(100vh - 191px)";
          }
        } else {
          switch (this.$vuetify.breakpoint.name) {
            case "xs":
              return "calc(100vh - 189px)";
            case "sm":
              return "calc(100vh - 189px)";
            case "md":
              return "calc(100vh - 189px)";
            case "lg":
              return "calc(100vh - 189px)";
            case "xl":
              return "calc(100vh - 189px)";
          }
        }
      },
      getranke() {
        if (this.$store.state.getranke.getranke.length === 0) {
          this.$store.dispatch("getranke/loadGetranke");
        }
        return this.$store.state.getranke.getranke;
      },
      statistiken() {
        if (this.$store.state.statistiken.statistiken.length === 0) {
          this.$store.dispatch("statistiken/loadStatistiken");
        }
        let currentMonat = new Date(new Date().setMonth(new Date().getMonth() - this.anzahl))
          .toISOString()
          .substr(0, 7);
        let monate = [];
        this.$store.state.statistiken.statistiken.forEach((monat) => {
          if (monat.monat >= currentMonat) {
            monate.push(monat);
          }
        });
        let ergebnis = {
          eingekauft: { data: [], summe: 0, max: 0 },
          ekp: { data: [], summe: 0, max: 0 },
          verbraucht: { data: [], summe: 0, max: 0 },
          anfang: { data: [] },
          ende: { data: [] },
          monate: [],
        };
        if (this.getrank.bezeichnung) {
          let kategorie = "";
          if (this.getrank.kategorie === "Bier") {
            kategorie = "verbrauchBier";
          }
          if (this.getrank.kategorie === "Softdrinks") {
            kategorie = "verbrauchSoftdrinks";
          }
          if (this.getrank.kategorie === "Wein & Schnaps") {
            kategorie = "verbrauchWeinSchnaps";
          }
          monate.forEach((monat) => {
            let elemente = monat[kategorie].find((item) => item.bezeichnung === this.getrank.bezeichnung);
            if (elemente) {
              ergebnis.eingekauft.data.push(elemente.eingekauft);
              ergebnis.eingekauft.summe += parseInt(elemente.eingekauft);
              if (ergebnis.eingekauft.max < parseInt(elemente.eingekauft)) {
                ergebnis.eingekauft.max === parseInt(elemente.eingekauft);
              }
              ergebnis.ekp.data.push(elemente.ekp);
              ergebnis.ekp.summe += parseInt(elemente.ekp);
              if (ergebnis.ekp.max < parseInt(elemente.ekp)) {
                ergebnis.ekp.max === parseInt(elemente.ekp);
              }
              ergebnis.verbraucht.data.push(elemente.verbraucht);
              ergebnis.verbraucht.summe += parseInt(elemente.verbraucht);
              if (ergebnis.verbraucht.max < parseInt(elemente.verbraucht)) {
                ergebnis.verbraucht.max === parseInt(elemente.verbraucht);
              }
              ergebnis.anfang.data.push(elemente.anfang);
              ergebnis.ende.data.push(elemente.ende);
              ergebnis.monate.push(monat.monat);
            }
          });
        }
        return ergebnis;
      },
      preisexcl() {
        if (this.getrank.preis) {
          return ((this.getrank.preis.replace(",", ".") / 119) * 100).toFixed(2);
        } else {
          return;
        }
      },
    },
    methods: {
      createGetrank() {
        const getrank = {
          bezeichnung: this.getrank.bezeichnung,
          kategorie: this.getrank.kategorie,
          striche: this.getrank.striche,
          switchBestellung: this.getrank.switchBestellung,
          switchEkp: this.getrank.switchEkp,
          switchPfand: this.getrank.switchPfand,
          switchZahlung: this.getrank.switchZahlung,
          verkaufseinheit: this.getrank.verkaufseinheit,
          volumen: parseFloat(this.getrank.volumen.replace(",", ".")).toFixed(2),
          preis: parseFloat(this.getrank.preis.replace(",", ".")).toFixed(2),
          pfand: parseFloat(this.getrank.pfand.replace(",", ".")).toFixed(2),
          verkauf1: parseFloat(this.getrank.verkauf1.replace(",", ".")).toFixed(2),
          verkauf2: parseFloat(this.getrank.verkauf2.replace(",", ".")).toFixed(2),
          verkauf3: parseFloat(this.getrank.verkauf3.replace(",", ".")).toFixed(2),
        };
        console.log(getrank);
        this.$store.dispatch("getranke/createGetrank", getrank);
        this.showGetrank = false;
        this.getrank = [];
      },
      updateGetrank() {
        this.getrank.volumen = parseFloat(this.getrank.volumen.replace(",", ".")).toFixed(2);
        this.getrank.preis = parseFloat(this.getrank.preis.replace(",", ".")).toFixed(2);
        this.getrank.pfand = parseFloat(this.getrank.pfand.replace(",", ".")).toFixed(2);
        this.getrank.verkauf1 = parseFloat(this.getrank.verkauf1.replace(",", ".")).toFixed(2);
        this.getrank.verkauf2 = parseFloat(this.getrank.verkauf2.replace(",", ".")).toFixed(2);
        this.getrank.verkauf3 = parseFloat(this.getrank.verkauf3.replace(",", ".")).toFixed(2);
        this.$store.dispatch("getranke/updateGetrankData", this.getrank);
        this.showGetrank = false;
        this.getrank = [];
      },
      deleteGetrank() {
        this.$store.dispatch("getranke/deleteGetrankData", this.getrank.id);
        this.showGetrank = false;
        this.getrank = [];
        this.showDeleteGetrank = false;
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// bierwartGetranke.vue?71df9bd1